import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";

import "./style.css";
import historyAction from "../../redux/history/action";
import alertMessage from "../../redux/auth/action";
import TabButton from "../../component/TabButton/TabButton";
import progIcon from "../../assets/icons/prog.png";
import certiIcon from "../../assets/icons/certi.png";
import statementIcon from "../../assets/icons/statement.svg";
import BenefitApplicationStatus from "./BenefitApplicationStatus";
import EnrollmentCertificate from "./EnrollmentCertificate";
import StatementGeneration from "./StatementGeneration";

class SelfService extends Component {
  state = {
    currentTab: "benefitApp"
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
  }

  render() {
    const { currentTab } = this.state;

    return (
      <Container>
        <Row className="flex1 p-0">
          <Col className="p-0 my-2" md={4}>
            <TabButton
              title="Benefit Application Status"
              icon={progIcon}
              tabBtnMainContainerClasses="pr-md-4"
              tabBtnMainContainerStyles={{ display: "flex", flex: 1 }}
              tabBtnContainerStyles={{ flex: 1 }}
              active={currentTab === "benefitApp"}
              onClick={() => {
                this.setState({ currentTab: "benefitApp" });
              }}
            />
          </Col>
          <Col className="p-0 my-2" md={4}>
            <TabButton
              title="Enrollment Certificate"
              icon={certiIcon}
              tabBtnMainContainerClasses="pr-1"
              tabBtnMainContainerStyles={{ display: "flex", flex: 1 }}
              tabBtnContainerStyles={{ flex: 1 }}
              active={currentTab === "enrollmentCertificate"}
              onClick={() => {
                this.setState({ currentTab: "enrollmentCertificate" });
              }}
            />
          </Col>
          <Col className="p-0 my-2" md={4}>
            <TabButton
              title="Statement Generation"
              icon={statementIcon}
              tabBtnMainContainerClasses="pr-1 pl-md-4"
              tabBtnMainContainerStyles={{ display: "flex", flex: 1 }}
              tabBtnContainerStyles={{ flex: 1 }}
              active={currentTab === "statementgeneration"}
              onClick={() => {
                this.setState({ currentTab: "statementgeneration" });
              }}
            />
          </Col>
        </Row>
        {currentTab === "benefitApp" && <BenefitApplicationStatus />}
        {currentTab === "enrollmentCertificate" && <EnrollmentCertificate />}
        {currentTab === "statementgeneration" && <StatementGeneration />}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  alertBox: alertMessage.setAlertMessage
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelfService);
